import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';

const BomItem = (props) => {
  const {
    line_in_file,
    identifier,
    description,
    qty_to_buy,
    unit_price,
    price_by_qty,
    user_action,
    reference_designator,
    qty_per_board,
  } = props;

  return (
    <tr
      className={classnames('', {
        'bg-will-provide': user_action == 'will_provide',
        'bg-dont-populate': user_action == 'do_not_populate',
      })}
    >
      <td className='text-center'>{line_in_file}</td>
      <td>{identifier}</td>
      <td>{reference_designator}</td>
      <td>{description}</td>
      <td className='text-center'>{qty_per_board}</td>
      <td className='text-center'>{qty_to_buy}</td>
      <td
        className={classnames('', {
          'text-center': unit_price == '-',
          'text-end': unit_price != '-',
        })}
      >
        {unit_price == '-' && unit_price}
        {unit_price != '-' && `${numeral(unit_price).format('0.00')}`}
      </td>
      <td
        className={classnames('', {
          'text-center': price_by_qty == '-',
          'text-end': price_by_qty != '-',
        })}
      >
        {price_by_qty == '-' && price_by_qty}
        {price_by_qty != '-' && `${numeral(price_by_qty).format('0.00')}`}
      </td>
    </tr>
  );
};

export default BomItem;
